import * as React from 'react';
import {
  ActionCard,
  Permission,
  RouteWrapper,
  Box,
  HeadingSection,
  Section,
  Content,
} from '../../components';

const Route = () => (
  <RouteWrapper title="CRM" requireAuth>
    <HeadingSection title="CRM" />
    <Section>
      <Content>
        <Box>
          <Permission require="MANAGE_COMPANIES">
            <ActionCard
              title="Companies"
              subtitle="Manage companies"
              icon="briefcase"
              link="/companies"
            />
          </Permission>
          <Permission require="MANAGE_DRIVERS">
            <ActionCard
              title="Drivers"
              subtitle="Manage drivers"
              icon="user"
              link="/drivers"
            />
          </Permission>
          <Permission require="MANAGE_BOOKINGS">
            <ActionCard
              title="Invoice Lookup"
              subtitle="Search for bookings by invoice number"
              icon="list"
              link="/bookings/search"
            />
          </Permission>
        </Box>
      </Content>
    </Section>
  </RouteWrapper>
);

export default Route;
